import { Viewer } from '@/pages/ExplorePage/Viewer';
import { Fragment, ReactNode } from 'react';
import { exploreLayout } from './ExploreLayout';
import { MobileTabBar } from './MobileTabBar';

const DefaultWrapper = ({ children }: { children: ReactNode }) => {
  return children;
};

export const ExploreMobileLayout = () => {
  const currentColumn = exploreLayout.currentColumn.useValue();
  const Wrapper = currentColumn.Wrapper ?? DefaultWrapper;

  return (
    <div className="grid grid-rows-[auto_min-content] grid-cols-1 h-full w-full overflow-hidden">
      <div className="overflow-auto">
        <Wrapper>
          {currentColumn.id !== 'viewer' &&
            currentColumn.widgets.map(widget => (
              <Fragment key={widget.id}>{widget.component}</Fragment>
            ))}

          <Viewer style={currentColumn.id === 'viewer' ? {} : { display: 'none' }} />
        </Wrapper>
      </div>

      <MobileTabBar />
    </div>
  );
};
